import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {networkDeviceActions} from "../../../actions/network-device.actions";
import {connect} from "react-redux";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {Link} from "react-router-dom";
import NetworkDeviceLogsTable from "./_components/NetworkDeviceLogsTable";

class NetworkDeviceLogsPage extends Component {

    state = {
        networkDeviceId: null
    };

    componentDidMount() {
        const id = this.props.match.params.id;
        const { dispatch } = this.props;
        dispatch(networkDeviceActions.getNetworkDeviceSimpleInfo(id));

        this.setState({
            networkDeviceId: id
        });
    }


    render() {
        const { t, simpleDeviceInfo } = this.props;

        const breadcrumb = [
            { value: 'network-device', path: '/panel/network-device' },
            { value: 'network-device-content', path: '#' },
            { value: simpleDeviceInfo?.label, path: '#' },
            { value: 'content-activity-log', path: '#' }
        ];

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <div className="row">
                    <div className="col-md-3">
                        <h3>{ t('logs') }</h3>
                        <h5 className='font-italic'>{simpleDeviceInfo?.label}</h5>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header">
                        <div className="button-group">
                            <Link to={"/panel/network-device"} className="btn btn-secondary float-right" >
                                <i className="fas fa-undo"> </i>
                                <span> {t('back-to-list')} </span>
                            </Link>
                        </div>
                    </div>
                    <div className="card-body">
                        { simpleDeviceInfo ? (<NetworkDeviceLogsTable networkDeviceId={simpleDeviceInfo?.id}/>) : (<React.Fragment/>)}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { simpleDeviceInfo } = state.networkDeviceReducer;
    return {
        simpleDeviceInfo
    }
};
export default withNamespaces()(connect(mapStateToProps)(NetworkDeviceLogsPage));
